import { render } from "./InstallPwa.vue?vue&type=template&id=4d90b2ca&scoped=true"
import script from "./InstallPwa.vue?vue&type=script&lang=js"
export * from "./InstallPwa.vue?vue&type=script&lang=js"

import "./InstallPwa.vue?vue&type=style&index=0&id=4d90b2ca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4d90b2ca"

export default script